//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { getIsSocialDashboardsEnabled } from '@account-settings/redux/accountSettings/selectors/getIsSocialDashboardsEnabled';
import { NavDropdownMenuItem } from '@legacy-components/nav3/navigation-menus/NavDropdownMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { PublishingMenu } from '@legacy-components/nav3/navigation-menus/dropdown-menus/PublishingMenu';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

interface Props {
  setIsMenuOpen: (isMenuOpen: boolean) => void;
}

export const PublishingNav = ({ setIsMenuOpen }: Props) => {
  const isSocialDashboardsEnabled = useSelector(getIsSocialDashboardsEnabled);

  if (!isSocialDashboardsEnabled) {
    return null;
  }

  return (
    <NavDropdownMenuItem
      activeNavGroup={[NavGroup.PUBLISHING]}
      content={<PublishingMenu />}
      setIsMenuOpen={setIsMenuOpen}
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.PUBLISHING_NAV}
    >
      Publishing
    </NavDropdownMenuItem>
  );
};
